import { Box } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React from "react";
import { IRootStore } from "../stores";
import { STEPS } from "../stores/utils";
import Schedule from "../tutor-revamp/Schedule";
import { useClientSteps } from "./utils";

type Props = {
  store: IRootStore;
};

const SchedulePage = ({ store }: Props) => {
  const { onSubmitSection, getFormWrapperProps } = useClientSteps(
    STEPS.SCHEDULE_INFO,
    store,
  );
  const scheduleProps = {
    ...getFormWrapperProps(STEPS.SCHEDULE_INFO),
    buttonProps: {
      width: "30%",
      float: "right",
    },
    buttonText: "Save",
    onSubmit: onSubmitSection,
  };
  return (
    <Box
      as="section"
      className="forms-section"
      maxW={["100%", "100%", "640px"]}
      px={[5, 8, 0]}
      py={[10, 12]}
      mx="auto"
    >
      <Schedule {...scheduleProps} />
    </Box>
  );
};

export default observer(SchedulePage);
